import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  insertFechaColor,
  getFechasColor,
  updateFechaColor,
  deleteFechaColor,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FECHAS_COLOR() {
  try {
    const fechasColorData = yield call(getFechasColor)
    if (fechasColorData.ok) {
      yield put({
        type: actions.FECHA_COLOR_LOAD_SUCCEEDED,
        payload: fechasColorData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar fechas color')
      put({
        type: actions.FECHA_COLOR_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FECHA_COLOR_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_FECHA_COLOR(action) {
  try {
    const fechaColorObj = yield call(insertFechaColor, action.payload)
    if (fechaColorObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha color creada correctamente')
      yield put({
        type: actions.FECHA_COLOR_INSERT_SUCCEEDED,
        payload: fechaColorObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear fecha color')
      yield put({
        type: actions.FECHA_COLOR_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear fecha color')
    yield all([
      put({
        type: actions.FECHA_COLOR_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_FECHA_COLOR(action) {
  try {
    const fechaColorObj = yield call(updateFechaColor, action.payload)
    if (fechaColorObj.ok) {
      putMessage(messageType.SUCCESS, 'Fecha color modificada correctamente')
      yield put({
        type: actions.FECHA_COLOR_UPDATE_SUCCEEDED,
        payload: fechaColorObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar fecha color')
      yield put({
        type: actions.FECHA_COLOR_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar fecha color')
    yield all([
      put({
        type: actions.FECHA_COLOR_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_FECHA_COLOR(action) {
  try {
    const fechaColorResult = yield call(deleteFechaColor, action.payload)
    if (fechaColorResult.ok) {
      putMessage(messageType.SUCCESS, 'Fecha color eliminada correctamente')
      yield put({
        type: actions.FECHA_COLOR_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Fecha color')
      yield put({
        type: actions.FECHA_COLOR_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Fecha color')
    yield all([
      put({
        type: actions.FECHA_COLOR_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FECHA_COLOR_LOAD_REQUESTED, GET_FECHAS_COLOR),
    takeEvery(actions.FECHA_COLOR_INSERT_REQUESTED, INSERT_FECHA_COLOR),
    takeEvery(actions.FECHA_COLOR_UPDATE_REQUESTED, UPDATE_FECHA_COLOR),
    takeEvery(actions.FECHA_COLOR_DELETE_REQUESTED, DELETE_FECHA_COLOR),
  ])
}
